import React from "react";

export class PokerTurnirPobjednici extends React.Component {

    constructor(props) {
        super(props);
        this.state = { pobjednici: null, loading: false, turnir: null };

        this.fetchData = this.fetchData.bind(this);
        this.setData = this.setData.bind(this);
        this.renderPobjednike = this.renderPobjednike.bind(this);
        this.renderPobjednikRow = this.renderPobjednikRow.bind(this);


    }

    componentDidMount() {
        this.fetchData(this.props.turnir);
    }



    fetchData(turnir) {
        this.props.showLoadingFn(true);
        this.setState({
            loading: true,
            pobjednici: null,
            turnir: turnir
        });

        var promises = Promise.all([casino.repos.pokerTurnirPobjedniciRepo.list(turnir)]);

        this.dataPromises = casino.utils.makeCancelablePromise(promises);
        this.dataPromises.promise.then(this.setData, function (reason) { });
    }
    componentWillUnmount() {
        if (this.dataPromises)
            this.dataPromises.cancel();
    }
    setData(data) {
        var [pobjednici] = data;

        this.setState({
            pobjednici: pobjednici,
            loading: false
        });

        this.props.showLoadingFn(false);
    }

    componentDidUpdate() {
        var trenutniTurnirNaziv = (this.state && this.state.turnir) || null;
        var noviTurnirNaziv = this.props.turnir || null;

        if (trenutniTurnirNaziv != noviTurnirNaziv && (this.state && !this.state.loading)) {
            this.fetchData(noviTurnirNaziv);
        }
    }

    //logika prebacena u componentDidUpdate
    // componentWillReceiveProps(nextProps) {
    //     var trenutniTurnirNaziv = (this.state && this.state.turnir) || null;
    //     var noviTurnirNaziv = nextProps.turnir || null;

    //     if (trenutniTurnirNaziv != noviTurnirNaziv && (this.state && !this.state.loading))
    //         this.fetchData(noviTurnirNaziv);
    // }

    renderPobjednike() {
        return <table className="table-1 v2 v3">
            <thead>
                <tr>
                    <th className="text-left text text-6">Datum</th>
                    <th className="mobile-visible text-left text text-6">Alias/Turnir</th>
                    <th className="mobile-hidden text-left text text-6">Alias</th>
                    <th className="mobile-hidden text-left text text-6">Turnir</th>
                    <th className="text-right text text-6">Dobitak</th>
                </tr>
            </thead>
            <tbody>
                {(!this.state || !this.state.pobjednici) && <tr className="horizontal-lines"><td colSpan="5"><span className="text text-1">Dohvaćanje pobjednika...</span></td></tr>}

                {this.state && this.state.pobjednici && !this.state.pobjednici.length && <tr className="horizontal-lines"><td colSpan="5"><span className="text text-1">Trenutno nema rezultata...</span></td></tr>}
                {this.state && this.state.pobjednici && this.state.pobjednici.map(this.renderPobjednikRow)}
            </tbody>
        </table>
    }
    renderPobjednikRow(pobjednik, i) {
        var datum = new Date(pobjednik.datum);

        return <tr key={i} className="horizontal-lines">
            <td>
                <span className="text text-1">{casino.utils.dateToTimeString(datum)}</span><br />
                <span className="text text-2">
                    {datum.getDate() + '.' + (datum.getMonth() + 1) + '.'}
                </span>
            </td>
            <td className="mobile-visible text text-1">
                <span className="text-bold">{pobjednik.nadimak}</span><br /> <span className="text text-2 ">{pobjednik.turnir}</span>
            </td>
            <td className="mobile-hidden text text-1 text-bold">{pobjednik.nadimak}</td>
            <td className="mobile-hidden text text-1">{pobjednik.turnir}</td>

            <td className="text-right text text-7">{casino.utils.numberWithCurrencyFromated(casino.utils.numberToEuro2(pobjednik.dobitak, true), 'EUR')}</td>
        </tr>

    }
    render() {
        return <div>
            {this.renderPobjednike()}
        </div>

    }
};
